import * as L from 'leaflet';
import 'mapbox-gl-leaflet';
import 'mapbox-gl/dist/mapbox-gl.css';
import { MapLayer, withLeaflet } from 'react-leaflet';
import type { ReactNode } from 'react';
const withLeafletCompat = withLeaflet as unknown as <T>(component: T) => T;


export interface IMapboxGLProps extends L.MapboxGLOptions {
  children?: ReactNode;
}


class MapBoxGLLayer extends MapLayer<IMapboxGLProps, L.Layer> {
  public static defaultProps: Partial<IMapboxGLProps> = {
    style: 'mapbox://styles/mapbox/satellite-streets-v12'
  };

  public createLeafletElement(props: IMapboxGLProps) {
    return L.mapboxGL(props);
  }

  public render() {
    return null;
  }
}


export default withLeafletCompat(MapBoxGLLayer as any);
